<template>
  <section class="c-section c-section--lection bg-demon">
    <ModalTour
      v-if="false && user && user.id && device == 'desktop'"
      :user="user"
      :enroll="course.enroll"
    >
    </ModalTour>
    <ModalReport
      v-if="user && user.id"
      :user="user"
      :course="course.title"
    />
    <ModalReview
      v-if="user && user.id && course.progress"
      :course="$route.params.course_id"
      :progress="course.progress.percentage"
      :playerProgress="virtualRoomPresets.player.progress"
      :curriculum="curriculum"
      :user="user"
      @fill-rating-star="fillRatingStar"
    />
    <ModalSuscription :body="modalSuscription"></ModalSuscription>
    <ModalExam></ModalExam>
    <ModalAlertRegister></ModalAlertRegister>
    <ModalStatus />
    <ModalWelcome
      v-if="course.title && course.progress"
      :course="course"
      :player="player"
    />

    <ModalWelcomeTrialPremium
      v-if="course.enroll && course.enroll.data"
      :enroll="course.enroll"
    />
    <ModalLimitedTrialPremium
      v-if="course.enroll && course.enroll.data"
      :course="course"
    />

    <Header
      v-show="device == 'mobile'"
      device="mobile"
      :enroll="course.enroll"
      :rating="ratingStatus"
      class="c-lection-header--mobile"
    />
    <div class="c-theater d-flex" :class="{'full' : virtualRoomPresets.theater}">
      <div class="c-theater__video">
        <section
          class="c-theater__container position-relative pb-3 mb-3"
          :class="{'container-fluid pt-3' : !virtualRoomPresets.theater}"
        >
          <div
            class="c-theater__goback mb-4 d-flex flex-column align-items-start"
            :class="{ 'enable' : isVideoHover }"
            @mouseover="isVideoHover = true"
            @mouseleave="isVideoHover = false"
          >
            <h1 class="fs-21 w-sbold mb-2 white">{{ titleLeccion }}</h1>

            <template v-if="user">
              <a
                :href="goBackLink"
                class="c-link c-link--white white d-flex align-items-center"
              >
                <i class="iconf-left-arrow d-flex align-items-center me-2"></i>
                {{goBackButton}}
              </a>
            </template>
            <template v-else-if="!user">
              <a
                :href="`${course.slug}`"
                class="c-link c-link--white white d-flex align-items-center"
              >
                <i class="iconf-left-arrow d-flex align-items-center me-2"></i>
                Volver al curso
              </a>
            </template>
          </div>
          <section
            v-if="content.body && (content.body.type == 'video' || content.body.type == 'text')"
            class="c-video"
            :class="content.playState"
          >
            <div
              v-if="content.body.type == 'video'"
              @mouseover="isVideoHover = true"
              @mouseleave="isVideoHover = false"
              class="c-video__body position-relative overflow-hidden"
            >
              <div v-html="content.body.media"></div>
              <div
                class="c-video__transition position-absolute w-100 h-100 text-center"
                :class="{'active' : autoPlayTransition.enable}"
              >
                <div class="row justify-content-center h-100">
                  <div class="col col-12 col-md-10 col-lg-8 h-100">
                    <div
                      class="d-flex flex-column align-center justify-content-center
                      p-3 p-lg-4 h-100"
                    >
                      <a
                        v-if="false"
                        :href="campaignLinkTrans"
                        target="_blank"
                        class="c-video__promo of--contain d-none d-lg-block mb-lg-3 mb-xl-4">
                        <img
                          class="h-100"
                          src="../assets/images/arcux/campaigns/2x1_2.png" alt=""
                        />
                      </a>
                      <p class="d-none d-md-block fs-14 w-medium white mb-0">
                        ¿Te gustó la lección?
                      </p>
                      <div class="d-none d-md-flex justify-content-center align-items-center mb-3">
                        <button
                          :disabled="content.likes.isLoading || !user || (user && !course.enroll)"
                          @click="addLike(1)"
                          class="c-link fs-25 mx-1 animate__animated animate__delay-2s"
                          :class="[
                            (content.likes.user_like == 1) ? 'c-link--primary' : 'c-link--white',
                            {'animate__bounceIn' : autoPlayTransition.enable}]
                          "
                        >
                          <i class="iconf-like"></i>
                        </button>

                        <button
                          :disabled="content.likes.isLoading || !user || (user && !course.enroll)"
                          @click="addLike(2)"
                          class="c-link fs-25 mx-1 animate__animated animate__delay-2s"
                          :class="[
                            (content.likes.user_like == 2) ? 'c-link--primary' : 'c-link--white',
                            {'animate__bounceIn' : autoPlayTransition.enable}]
                          "
                        >
                          <i class="iconf-dislike"></i>
                        </button>
                      </div>

                      <p class="fs-14 w-medium white mb-0">Siguiente clase</p>
                      <p class="fs-26 w-bold white mb-3">{{ autoPlayTransition.lection }}</p>
                      <div class="row justify-content-center">
                        <div class="col col-6 col-md-4 col-lg-5 col-xl-3">
                          <button
                            @click="cancelAutoplayNextLection()"
                            class="c-button c-button--white-ghost c-button--white-ghost-dark
                            small w-100 h-100"
                          >
                            Cancelar
                          </button>
                        </div>
                        <div class="col col-6 col-md-4 col-lg-5 col-xl-3">
                          <button
                            @click="playNextLection()"
                            class="c-play-next c-button c-button--primary small
                            w-100 h-100 position-relative p-0"
                            :class="{'active' : (autoPlayTransition.enable && !content.loading)}"
                            :disabled="content.loading"
                          >
                            <div
                              class="c-play-next__text position-relative h-100
                              d-flex justify-content-center align-items-center"
                            >
                              <i class="iconf-play me-2"></i>
                              {{ (content.loading) ? 'Cargando...' : 'Ver ahora' }}
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <VideoOverlay
                v-if="isFreeLimited"
                :toggle.sync="upgradeAdvertisment.isVideoEnable" :player="player"
              />
            </div>
            <div v-else class="c-video__text p-3 p-lg-4" v-html="content.body.description"></div>

            <VideoFooter
              v-if="isFreeLimited"
              :toggle.sync="upgradeAdvertisment.isFooterEnable"
            />

            <nav class="c-video__nav d-flex justify-content-between p-3">
              <div class="d-flex align-items-center">
                <button
                  :disabled="content.likes.isLoading || !user || (user && !course.enroll)"
                  @click="addLike(1)"
                  class="c-tooltip-toggle c-link me-3"
                  :class="(content.likes.user_like == 1) ? 'c-link--primary' : 'c-link--white'"
                  data-content="Me gusta esta clase"
                  data-v-step="5"
                >
                  <i class="iconf-like"></i>
                  <span class="w-medium ms-1">{{ content.likes.likes }}</span>
                </button>

                <button
                  :disabled="content.likes.isLoading || !user || (user && !course.enroll)"
                  @click="addLike(2)"
                  class="c-tooltip-toggle c-link me-3"
                  :class="(content.likes.user_like == 2) ? 'c-link--primary' : 'c-link--white'"
                  data-content="No me gusta esta clase"
                >
                  <i class="iconf-dislike"></i>
                  <span class="w-medium ms-1">{{ content.likes.dislikes }}</span>
                </button>
              </div>
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center me-3" data-v-step="7">
                  <Switcher
                    :state.sync="virtualRoomPresets.player.autoplay"
                    label="Reproducción automática"
                    class="c-ui-switcher--dark">
                  </Switcher>
                </div>
                <button
                  v-if="device == 'desktop'"
                  class="c-tooltip-toggle c-link c-link--white me-3"
                  data-content="Ampliar a modo cine"
                  data-v-step="6"
                  @click="virtualRoomPresets.theater = !virtualRoomPresets.theater"
                >
                  <i v-if="!virtualRoomPresets.theater" class="iconf-theater"></i>
                  <i v-else class="iconf-theater-filled"></i>
                </button>
                <button
                  @click="reportIssue('lection')"
                  :disabled="!user && !enroll ? true : false"
                  class="c-tooltip-toggle c-link c-link--white"
                  data-content="Reportar problema"
                  data-v-step="3">
                  <i class="iconf-warning"></i>
                </button>
              </div>
            </nav>
          </section>
          <section
            v-if="content.body
              && content.body.type == 'video'
              && content.body.description
              && course.teachers.length > 0"
            class="mt-4">
            <section :class="{'container-fluid' : virtualRoomPresets.theater}">
              <div class="c-comment c-comment--teacher d-flex">
                <Avatar
                  role="teacher"
                  :photo="course.teachers[0].photo"
                  :name="course.teachers[0].display_name"
                  class="c-avatar--tiny d-none d-md-block me-3">
                </Avatar>
                <div class="flex-grow-1">
                  <div class="d-flex align-items-center white mb-3 mb-md-2">
                    <Avatar
                      role="teacher"
                      :photo="course.teachers[0].photo"
                      :name="course.teachers[0].display_name"
                      class="c-avatar--tiny d-md-none me-3">
                    </Avatar>
                    <span class="w-bold">
                      {{course.teachers[0].firstname}} {{course.teachers[0].lastname}}
                    </span>
                    <span class="c-comment__label ms-2">Docente</span>
                  </div>
                  <div
                    class="medium-gray w-medium c-body-description"
                    v-html="content.body.description"
                  >
                  </div>
                </div>
              </div>
            </section>
          </section>
          <Homework
            v-if="content.body && content.body.type === 'homework' && course.progress"
            :user="user"
            :course="course"
            :content="content"
            :last="lastLectionIncompleted"
            @open-issue-modal="reportIssue"
          ></Homework>
        </section>
        <Thread
          v-if="device == 'desktop' && isAvaibleThread && content.body.type != 'homework'"
          :user="user"
          :course="course"
          class="mb-4"
        />
      </div>
      <div class="c-theater__sidebar bg-darks">
        <section class="c-sidebar d-flex flex-column">
          <Header
            v-show="device == 'desktop'"
            device="desktop"
            :enroll="course.enroll"
            :rating="ratingStatus"
          />

          <section class="bg-shadows py-lg-4">
            <a
              v-if="false"
              :href="campaignLinkTemario"
              target="_blank"
              class="c-sidebar__promo of--contain d-block">
              <img
                class="w-100"
                src="../assets/images/arcux/campaigns/2x1_2.png" alt=""
              />
            </a>
          </section>

          <div class="container-fluid bg-shadows">
            <h2 class="fs-21 text-center w-bold white pt-4 pt-lg-3 pb-4 mb-0">{{course.title}}</h2>
          </div>

          <div class="container-fluid pb-4 bg-shadows">
            <ProgressBar
              v-if="course.progress"
              class="c-progress-bar--black"
              :percentage="(course.progress.percentage <= 100) ? course.progress.percentage : 100"
            />
          </div>

          <!-- TODO: Mejorar este timer, cuando el toogle esta false hay paddings visible -->
          <div
            v-if="isFreeLimited"
            class="container-fluid pb-4 bg-shadows"
          >
            <TimerInline :end="course.access.expiration.date_full" />
          </div>

          <section class="c-shortcuts flex-grow-1 d-flex flex-column">
            <b-tabs class="c-shortcuts-tabs">
              <b-tab title="Temario" active>
                <Modules
                  v-if="curriculum.isReady"
                  :user.sync="user"
                  :content="content"
                  :course="course"
                  :curriculum="curriculum"
                  :is-teacher="isTeacher"
                >
                </Modules>
              </b-tab>
              <b-tab title="Materiales">
                <section
                  v-if="curriculum.resources.main.length > 0
                    || curriculum.resources.free.length > 0"
                >
                  <ul class="c-accordion ul-reset">
                    <li
                      v-if="curriculum.resources.main.length > 0"
                      class="c-accordion__item c-module c-module--bundle"
                    >
                      <input id="main-materials" class="d-none" type="checkbox" checked>
                      <label for="main-materials">
                        <div class="c-switcher d-flex justify-content-between">
                          <p class="c-switcher__title mb-0 white w-bold">
                            <span>Materiales del curso</span>
                          </p>
                          <div class="c-switcher__arrow d-flex align-items-center ms-2">
                            <i class="iconf-arrow-down d-flex align-items-center"></i>
                          </div>
                        </div>
                      </label>
                      <div class="c-body">
                        <ul class="c-module__materials">
                          <li
                            v-for="resource of curriculum.resources.main"
                            :key="resource.id"
                            class="c-material"
                          >
                            <a
                              :href="resource.url"
                              target="_blank"
                              download
                              class="d-flex justify-content-between align-items-center"
                            >
                              <div class="c-material__name d-flex flex-grow-1 me-2">
                                <span class="me-2">
                                  <i class="iconf-download"></i>
                                </span>
                                <div class="c-material__titles">
                                  <p class="mb-0 w-medium">{{resource.name}}</p>
                                </div>
                              </div>
                              <span class="d-none medium-gray fs-14">
                                12MB
                              </span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li
                      v-if="curriculum.resources.free.length > 0"
                      class="c-accordion__item c-module c-module--bundle"
                    >
                      <input id="free-materials" class="d-none" type="checkbox" checked>
                      <label for="free-materials">
                        <div class="c-switcher d-flex justify-content-between">
                          <p class="c-switcher__title mb-0 white w-bold">
                            <span>Bonus del curso</span>
                            <i class="iconf-gift ms-2"></i>
                          </p>
                          <div class="c-switcher__arrow d-flex align-items-center ms-2">
                            <i class="iconf-arrow-down d-flex align-items-center"></i>
                          </div>
                        </div>
                      </label>
                      <div class="c-body">
                        <ul class="c-module__materials">
                          <li
                            v-for="freResource of curriculum.resources.free"
                            :key="freResource.id"
                            class="c-material"
                          >
                            <a
                              :href="freResource.url"
                              target="_blank"
                              download
                              class="d-flex justify-content-between align-items-center"
                            >
                              <div class="c-material__name d-flex flex-grow-1 me-2">
                                <span class="me-2">
                                  <i class="iconf-download"></i>
                                </span>
                                <div class="c-material__titles">
                                  <p class="mb-0 w-medium">{{freResource.name}}</p>
                                </div>
                              </div>
                              <span class="d-none medium-gray fs-14">
                                12MB
                              </span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </section>
                <section v-else-if="course.enroll" class="text-center">
                  <h3 class="w-bold fs-21 white mb-2">
                    Este curso no incluye archivos descargables.
                  </h3>
                  <p class="mb-0 w-medium medium-gray">¿Crees que se trata de un error?
                    <button
                      :disabled="!user && !enroll ? true : false"
                      class="c-link"
                      @click="reportIssue('resources')"
                    >
                      Reportar problema
                    </button>
                  </p>
                </section>
                <section v-else class="text-center">
                  <h3 class="w-bold fs-21 white mb-2">Lo sentimos!, no tienes acceso completo</h3>
                  <p class="mb-0 w-medium medium-gray">
                    Para disfrutar del curso, debes ser premium
                    <a href="/planes" class="c-link">ver planes</a>.
                  </p>
                </section>
              </b-tab>
            </b-tabs>
          </section>
        </section>
      </div>
    </div>
    <Thread
      v-if="device == 'mobile' && isAvaibleThread && content.body.type != 'homework'"
      :user="user"
      :course="course"
      class="mt-4 pb-4"
    />

    <v-tour name="tour" :options="tour.options" :steps="tour.steps"></v-tour>
  </section>
</template>
<script>
import Vue from 'vue';
import tippy from 'tippy.js';
import Player from '@vimeo/player';
import VueTour from 'vue-tour';

import { mapState, mapActions, mapMutations } from 'vuex';

import Header from '../components/lection/Header.vue';
import ProgressBar from '../components/ProgressBar.vue';
import Switcher from '../components/ui/Switcher.vue';

import ModalTour from '../components/lection/modals/ModalTour.vue';
import ModalReport from '../components/lection/modals/ModalReport.vue';
import ModalReview from '../components/lection/modals/ModalReview.vue';
import ModalSuscription from '../components/membership/ModalSuscription.vue';
import ModalExam from '../components/lection/modals/ModalExam.vue';
import ModalAlertRegister from '../components/lection/modals/ModalAlertRegister.vue';

import Thread from '../components/lection/feedback/Thread.vue';
import Modules from '../components/lection/Modules.vue';
import Avatar from '../components/Avatar.vue';
import Homework from '../components/lection/Homework.vue';

import TimerInline from '../components/TimerInline.vue';

Vue.use(VueTour);

export default {
  data() {
    return {
      arcux: window.arcux,
      user: window.arcux.user,

      mixpanel: {},
      course: {
        slug: '',
        title: '',
        progress: null,
        enroll: false,
        certificate: false,
        access: null,
        teachers: [],
        details: {},
        default_price: null,
      },
      curriculum: {
        modules: [],
        homeworks: [],
        lessons: {
          total: 0,
          data: [],
        },
        resources: {
          main: [],
          free: [],
        },
        exam: '',
        isReady: false,
      },
      content: {
        loading: false,
        body: null,
        preview: false,
        previous: false,
        next: false,
        likes: {
          isLoading: false,
          likes: 0,
          dislikes: 0,
          user_like: 0,
        },
        tooltips: false,
        playState: 'played',
      },

      isResized: false,
      isVideoHover: false,
      device: '',
      player: null,
      virtualRoomPresets: {},

      frezedAutoplay: false,
      autoPlayTransition: {
        enable: false,
        lection: 'lection_title',
      },
      upgradeAdvertisment: {
        isVideoEnable: true,
        isFooterEnable: false,
      },

      sidebar: {
        status: localStorage.getItem('sidebarStatus'),
      },
      ratingStatus: false,
      tour: {
        options: {
          labels: {
            buttonSkip: 'Saltar',
            buttonPrevious: 'Anterior',
            buttonNext: 'Siguiente',
            buttonStop: 'Finalizar',
          },
        },
        steps: [
          {
            target: '[data-v-step="1"]',
            content: `
              <div class="c-guide-tour">
                <h4 class="c-guide-tour__title">Reorganizamos los materiales</h4>
                <p class="c-guide-tour__desc">Ahora podrás descargarlos de forma sencilla y en un solo lugar.</p>
              </div>
            `,
          },
          {
            target: '[data-v-step="2"]',
            content: `
              <div class="c-guide-tour">
                <h4 class="c-guide-tour__title">Una sección de comentarios mejorada</h4>
                <p class="c-guide-tour__desc">Ahora será más sencillo compartir tus dudas o comentarios y responder a tus compañeros.</p>
              </div>
            `,
          },
          {
            target: '[data-v-step="3"]',
            content: `
              <div class="c-guide-tour">
                <h4 class="c-guide-tour__title">Reporta cualquier problema</h4>
                <p class="c-guide-tour__desc">Comparte con nosotros cualquier incidente dentro del curso y ayudamos a mejorar.</p>
              </div>
            `,
          },
          {
            target: '[data-v-step="4"]',
            content: `
              <div class="c-guide-tour">
                <h4 class="c-guide-tour__title">Valora nuestro curso</h4>
                <p class="c-guide-tour__desc">Se libre de valorar la calidad de nuestro curso y cuéntanos como podemos mejorar.</p>
              </div>
            `,
          },
          {
            target: '[data-v-step="5"]',
            content: `
              <div class="c-guide-tour">
                <h4 class="c-guide-tour__title">Califica nuestras clases</h4>
                <p class="c-guide-tour__desc">Comparte si te gusto o no el contenido que has visto, esto nos ayudará a mejorar el curso.</p>
              </div>
            `,
          },
          {
            target: '[data-v-step="6"]',
            content: `
              <div class="c-guide-tour">
                <h4 class="c-guide-tour__title">Modo cine disponible</h4>
                <p class="c-guide-tour__desc">Activalo si deseas tener mayor concentración en cada clase.</p>
              </div>
            `,
          },
          {
            target: '[data-v-step="7"]',
            content: `
              <div class="c-guide-tour">
                <h4 class="c-guide-tour__title">Reproducción automática disponible</h4>
                <p class="c-guide-tour__desc">Activala y disfruta del cursos sin necesidad de moverte o cambiar de leccion a cada momento.</p>
              </div>
            `,
          },
        ],
      },

      modalSuscription: {
        title: '¡Alto ahí esponja!',
        description: 'Para acceder a los examenes y certificados necesitas subir a un plan premium.',
      },

      progressVideoTime: {},
      currentProgressLesson: '',
    };
  },
  components: {
    Header,
    ProgressBar,

    ModalReport,
    ModalReview,
    ModalTour,
    ModalSuscription,
    ModalExam,
    ModalAlertRegister,

    Thread,
    Modules,
    Avatar,
    Homework,

    Switcher,
    TimerInline,

    ModalStatus: () => import(/* webpackChunkName: "modal-status" */'@/components/lection/modals/ModalStatus.vue'),
    ModalWelcome: () => import(/* webpackChunkName: "modal-welcome" */'@/components/lection/modals/ModalWelcome.vue'),
    ModalWelcomeTrialPremium: () => import(/* webpackChunkName: "modal-welcome-trial-premium" */'@/components/lection/modals/ModalWelcomeTrialPremium.vue'),
    ModalLimitedTrialPremium: () => import(/* webpackChunkName: "modal-limited-trial-premium" */'@/components/lection/modals/ModalLimitedTrialPremium.vue'),
    VideoOverlay: () => import(/* webpackChunkName: "video-overlay" */'@/components/lection/player/Overlay.vue'),
    VideoFooter: () => import(/* webpackChunkName: "video-footer" */'@/components/lection/player/Footer.vue'),
  },
  computed: {
    ...mapState({
      report: (state) => state.modals.report,
      userFilled: (state) => state.user.userFilled,
      userData: (state) => state.user.userData,
    }),
    breakpoint: {
      get() {
        return this.device;
      },
    },
    isTeacher: {
      get() {
        return (this.user && this.user.id) ? (this.user.roles.includes('teacher') || this.user.roles.includes('teacher-pro')) : false;
      },
    },
    lastLectionIncompleted: {
      get() {
        const lastLection = [];

        this.curriculum.modules.forEach((module) => {
          const incompletedLections = module.lessons.filter((lection) => !lection.completed);

          if (incompletedLections.length) {
            const incompletedLection = (incompletedLections.reverse()).pop();

            lastLection.push({
              moduleNumber: module.number,
              lectionSlug: incompletedLection.slug,
            });
          }
        });

        return lastLection.length
          ? (lastLection.reverse()).pop()
          : lastLection;
      },
    },
    titleLeccion() {
      return this.content.body ? this.content.body.title : '';
    },
    isAvaibleThread() {
      if (this.content.body) {
        return (this.course.enroll && this.content.type !== 'homework');
      }

      return false;
    },
    campaignLinkTemario() {
      return 'https://news.arcux.net/2x1';
    },
    campaignLinkTrans() {
      return 'https://news.arcux.net/2x1';
    },

    goBackLink() {
      return (this.$route.params.speciality_id)
        ? `/panel/especialidad/${this.$route.params.speciality_id}`
        : '/panel';
    },
    goBackButton() {
      return (this.$route.params.speciality_id)
        ? 'Volver a la especialidad'
        : 'Volver a mis cursos';
    },
    isFreeLimited() {
      return this.course.access
        && this.course.access.plan === 'free'
        && this.course.access.expiration
        && this.course.access.expiration.date_full;
    },
  },
  watch: {
    /* eslint-disable */
    $route() {
      this.getEnrollmentStatus();
      this.getContent();
      this.getLikes();
      this.setNavigation(this.curriculum);
    },
    'course.title': function() {
      this.runActions();
    },
    'course.progress': function() {
      this.runActions();
    },
    'content.body': function() {
      this.runActions();
    },
    'content.previous': function() {
      this.runActionsPlayer();
    },
    'content.next': function() {
      this.runActionsPlayer();
    },

    player() {
      this.runActionsPlayer();
    },
    'virtualRoomPresets.player.autoplay': function() {
      window.localStorage.setItem('arcux_virtual_room', JSON.stringify(this.virtualRoomPresets));
    },
    'virtualRoomPresets.player.progress': function() {
      window.localStorage.setItem('arcux_virtual_room', JSON.stringify(this.virtualRoomPresets));
    },
    'virtualRoomPresets.theater': function() {
      window.localStorage.setItem('arcux_virtual_room', JSON.stringify(this.virtualRoomPresets));
    },
    'virtualRoomPresets.playbackRate': function() {
      window.localStorage.setItem('arcux_virtual_room', JSON.stringify(this.virtualRoomPresets));
    },

    userData(data) {
      this.user = data;

      this.getEnrollmentStatus();
      this.getResources();
      this.getContent();
    },
  },
  mounted() {
    this.user = this.userData;

    const breakpoint = window.matchMedia('(min-width: 1024px)');

    this.initVirtualRoomPresets();

    this.getData();
    this.getContent();
    this.getCurriculum();
    this.getLikes();

    if (this.user && this.user.id) {
      this.getEnrollmentStatus();
      this.getResources();
      this.getContent();
    }

    this.checkDevice(breakpoint); breakpoint.addEventListener('change', this.checkDevice);
    this.hideSidebar('init');
  },
  methods: {
    ...mapActions(['openReportModal']),
    ...mapMutations(['updateUserFilled']),
    ...mapMutations(['updateCourseData']),
    reportIssue(type) {
      let lection;
      const mainModule = this.curriculum.modules
        .find((mod) => Number(mod.number) === Number(this.$route.params.module));

      if (type === 'homework') {
        lection = this.curriculum.homeworks
          .find((homework) => (
            homework.slug === this.$route.params.lection_slug
            && Number(homework.module) === Number(this.$route.params.module)
          ));
      } else if (type === 'lection') {
        lection = this.curriculum.lessons.data
          .find((lect) => (
            lect.slug === this.$route.params.lection_slug
            && Number(lect.module) === Number(this.$route.params.module)
          ));
      } else {
        lection = { title: '' };
      }

      this.openReportModal({
        type,
        module: mainModule.title,
        lection: lection.title,
      });

      this.$bvModal.show('modalReport');
    },
    getEnrollmentStatus() {
      const request = `${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/students/${this.user.id}`;

      fetch(request, {
        headers: {
          ...((window.arcux.token) && {Authorization: `Bearer ${window.arcux.token}`}),
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          this.course.enroll = response;

          this.getProgress();
        })
        .catch((err) => {
          this.course.enroll = false; throw err;
        });
    },
    getData() {
      /* eslint-disable */
      const request = `${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/lection-data/`;

      fetch(request, {
        headers: {
          ...((window.arcux.token) && {Authorization: `Bearer ${window.arcux.token}`}),
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((data) => {
          this.course.slug = data.slug;
          this.course.title = data.title;
          this.course.certificate = data.certificate;
          this.course.exam_access = data.exam_access;
          this.course.teachers = data.teachers;
          this.course.details = data.details;
          this.course.default_price = data.default_price;

          if (data.plan_access && data.expiration_date)
            this.course.access = {
              plan: data.plan_access,
              expiration: data.expiration_date,
            };

          this.updateCourseData({
            data: {
              is_free: data.is_free
            }
          });
        })
        .catch((err) => {
          throw err;
        });
    },
    getCurriculum() {
      /* eslint-disable */
      const request = `${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/virtual-room/temary/`;

      fetch(request, {
        headers: {
          ...((window.arcux.token) && {Authorization: `Bearer ${window.arcux.token}`}),
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((curriculum) => {
          this.curriculum.homeworks = curriculum.homeworks;
          this.curriculum.modules = Object.values(curriculum.modules).map((mod) => (
            {
              ...mod,
              lessons: Object.values(mod.lessons),
            }
          ));

          this.curriculum.lessons.total = curriculum.total_lessons;
          this.curriculum.modules.forEach((mod) => {
            this.curriculum.lessons.data = this.curriculum.lessons.data.concat(mod.lessons);
          });
          this.curriculum.exam = curriculum.exam;
          this.curriculum.isReady = true;

          this.setNavigation(this.curriculum);
        })
        .catch((err) => {
          throw err;
        });
    },
    getResources() {
      const request = `${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/resources/?userId=${this.user.id}`;

      fetch(request, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((resources) => {
          this.curriculum.resources.main = resources.course_resources;
          this.curriculum.resources.free = resources.course_bonus;
        })
        .catch((err) => {
          throw err;
        });
    },
    getProgress() {
      const request = `${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/students/${this.user.id}/progress/`;

      fetch(request, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((progress) => {
          this.course.progress = progress;
          this.currentProgressLesson = progress.lessons
            .find((pr) => pr.lesson === this.$route.params.lection_slug);

          this.markComplete();
        })
        .catch((err) => {
          throw err;
        });
    },
    saveProgress() {
      if (
        !this.content.loading
        && !this.course.progress.lessons
          .find((lection) => (
            Number(lection.module) === Number(this.$route.params.module)
            && lection.lesson === this.$route.params.lection_slug
          ))
        && this.content.body.type !== 'homework'
      ) {
        const request = `${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/students/${this.user.id}/progress/`;
        const formData = new FormData();
        const hasStarted = (!this.course.progress || this.course.progress.percentage === 0);
        let hasEnded = false;

        this.content.loading = true;

        formData.append('courseId', this.$route.params.course_id);
        formData.append('userId', this.user.id);
        formData.append('moduleId', this.$route.params.module);
        formData.append('lesson', this.$route.params.lection_slug);
        formData.append('progressLessons', this.course.progress.total + 1);
        formData.append('totalLessons', this.curriculum.lessons.total);

        fetch(request, {
          body: formData,
          method: 'POST',
          headers: {
            Authorization: `Bearer ${window.arcux.token}`,
          },
        })
          .then((res) => {
            if (res.status === 200 || res.status < 300) {
              return res.json();
            }

            throw res;
          })
          .then((percentage) => {
            this.content.loading = false;
            this.course.progress.total += 1;
            this.course.progress.percentage = percentage;
            this.course.progress.lessons.push({
              module: this.$route.params.module,
              lesson: this.$route.params.lection_slug,
            });

            hasEnded = (Number(this.course.progress.percentage) === 100);

            this.markComplete();

            if (this.course.details.categories && this.course.details.categories) {
              this.markAsCompleted(hasStarted, hasEnded);
            }
          })
          .catch((err) => {
            this.content.loading = false; throw err;
          });
      } else {
        this.content.loading = false;
      }
    },
    markComplete() {
      /* eslint-disable */
      this.curriculum.modules = this.curriculum.modules.map( mod => {
        return {
          ...mod,
          completed: this.course.progress.lessons.filter(lesson => (lesson.module == mod.number)).length == mod.total_lessons,
          lessons: mod.lessons.map(_lesson => {
            return {
              ..._lesson,
              completed: (this.course.progress.lessons.find(lesson => lesson.module == _lesson.module && lesson.lesson == _lesson.slug)) ? true : false,
            }
          }),
        }
      })
    },

    getContent() {
      /* eslint-disable */
      const request = `${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/${this.$route.params.module}/${this.$route.params.lection_slug}`;

      this.content.loading = true;
      this.player = false;

      fetch(request, {
        headers: {
          ...((window.arcux.token) && {Authorization: `Bearer ${window.arcux.token}`}),
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((content) => {
          this.content.preview = true;
          this.content.body = content;
          this.content.body.mediaURL = content.media;

          this.updateUserFilled({
            userFilled: content.userFilled,
          });

          if (content.type === 'video') {
            this.initPlayer();
          }
        })
        .catch((err) => {
          this.content.preview = false;
          this.content.loading = false;
          this.$bvModal.show('alertRegister');

          throw err;
        });
    },

    getLikes() {
      const request = `${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/${this.$route.params.module}/${this.$route.params.lection_slug}/likes`;

      this.content.likes.isLoading = true;

      fetch(request)
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.content.likes = response.data;
          }

          this.content.likes.isLoading = false;
        })
        .catch((err) => {
          this.content.likes.isLoading = false;

          throw err;
        });
    },
    addLike(likeType) {
      const request = `${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/${this.$route.params.module}/${this.$route.params.lection_slug}/likes`;

      const formData = new FormData();
      let finalLikeType = -1;

      if (this.content.likes.user_like) {
        finalLikeType = (this.content.likes.user_like !== likeType) ? likeType : 0;
      } else {
        finalLikeType = likeType;
      }

      formData.append('userId', this.user.id);
      formData.append('liked', finalLikeType);

      fetch(request, {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            if (finalLikeType) {
              if (finalLikeType === 1) {
                if (this.content.likes.user_like) {
                  this.content.likes.dislikes -= 1;
                }

                this.content.likes.likes += 1;
                this.content.likes.user_like = 1;
              } else {
                if (this.content.likes.user_like) {
                  this.content.likes.likes -= 1;
                }

                this.content.likes.dislikes += 1;
                this.content.likes.user_like = 2;
              }
            } else {
              if (this.content.likes.user_like === 1) {
                this.content.likes.likes -= 1;
              } else {
                this.content.likes.dislikes -= 1;
              }

              this.content.likes.user_like = 0;
            }
          }
        })
        .catch((err) => {
          throw err;
        });
    },

    setNavigation(curriculum) {
      curriculum.lessons.data.forEach((lection, index) => {
        if (
          Number(lection.module) === Number(this.$route.params.module)
          && lection.slug === this.$route.params.lection_slug
        ) {
          this.content.previous = (index > 0) ? curriculum.lessons.data[index - 1] : false;
          this.content.next = (index < curriculum.lessons.data.length - 1)
            ? curriculum.lessons.data[index + 1]
            : false;
        }
      });
    },
    activeTab(value) {
      if (value === 'question' && this.questions.data.length === 0 && !this.questions.metas.isLoading) {
        this.getComments('questions', this.$route.params.module, this.$route.params.lection_slug);
      }

      this.tabs.active = value;
    },
    checkDevice(breakpoint) {
      if (breakpoint.matches) {
        this.device = 'desktop';
      } else {
        this.device = 'mobile';
      }
    },

    initVirtualRoomPresets() {
      let virtualRoom = window.localStorage.getItem('arcux_virtual_room');

      if (virtualRoom) {
        virtualRoom = JSON.parse(virtualRoom);
        virtualRoom.player.progress = 0;
      }

      this.virtualRoomPresets = virtualRoom
        ?? { player: { autoplay: false, progress: 0, playbackRate: 1 }, theater: false };
    },
    initPlayer() {
      const mediaURL = new URL(this.content.body.mediaURL);
      let mediaSRC = '';

      if ((new RegExp('youtube')).test(mediaURL.hostname)) {
        mediaSRC = `https://www.youtube.com/embed/${(new URLSearchParams(mediaURL.search)).get('v')}`;
      } else if ((new RegExp('vimeo')).test(mediaURL.hostname)) {
        mediaSRC = `https://player.vimeo.com/video${mediaURL.pathname}`;
      }

      this.content.body.media = `
        <div class="video-embed">
          <iframe src="${mediaSRC}"
            allowfullscreen
            allowtransparency
            allow="autoplay"
            muted
          ></iframe>
        </div>
      `;

      this.initTooltips();

      this.autoPlayTransition.enable = false;

      window.setTimeout(() => {
        this.player = new Player(document.querySelector('iframe'));

        this.player.on('loaded', () => {
          this.frezedAutoplay = false;

          document.querySelector('iframe').muted = false;

          this.player.setPlaybackRate(this.virtualRoomPresets.player.playbackRate);
          this.player.play();

          this.markAsWatched();
        });

        this.player.on('progress', (data) => {
          this.progressVideoTime = data;
          this.virtualRoomPresets.player.progress = data;
        });

        this.player.on('ended', () => {
          if (this.content.next && this.virtualRoomPresets.player.autoplay) {
            this.autoPlayTransition.enable = true;
            this.autoPlayTransition.lection = this.content.next.title;

            window.setTimeout(() => {
              if (!this.frezedAutoplay) {
                this.$router.push(`/curso/${this.$route.params.course_id}/lecciones/${this.content.next.module}/${this.content.next.slug}`);
              }
            }, 3000);
          }
        });

        this.player.on('playbackratechange', (data) => {
          this.virtualRoomPresets.player.playbackRate = data.playbackRate;
        });

        this.player.on('play', () => {
          this.content.playState = 'played';

          setTimeout(() => {
            this.content.playState = '';
          }, 500);
        });

        this.player.on('pause', () => {
          this.content.playState = 'paused';
          this.upgradeAdvertisment.isVideoEnable = true;

          setTimeout(() => {
            this.content.playState = '';
          }, 500);
        });

        this.initTrackingTimeWatched();
      }, 100);
    },
    initPlayerControls(player) {
      const playerControls = document.createElement('div');

      playerControls.setAttribute('id', 'player-controls');
      playerControls.innerHTML = `
        <div id="controls" class="c-video__controls w-100 h-50 position-absolute">
          <div class="c-video__play d-flex justify-content-center align-items-center position-absolute">
            <i class="iconf-play fs-30 align-items-center"></i>
            <i class="iconf-pause fs-30 align-items-center"></i>
          </div>
          ${(this.content.previous) ? `
              <button id="player-control-prev" class="c-video__prev c-button c-button--white-ghost-rounded medium">
                <i class="iconf-arrow-left d-flex align-items-center"></i>
              </button>
            ` : ''}
          ${(this.content.next) ? `
              <button id="player-control-next" class="c-video__next c-button c-button--white-ghost-rounded medium">
                <i class="iconf-arrow-right d-flex align-items-center"></i>
              </button>
            ` : ''}
        </div>
      `;

      player.appendChild(playerControls);

      const playerControlPrev = document.querySelector('#player-control-prev');
      const playerControlNext = document.querySelector('#player-control-next');

      if (playerControlPrev) {
        playerControlPrev.onclick = () => {
          this.$router.push(`/curso/${this.$route.params.course_id}/lecciones/${this.content.previous.module}/${this.content.previous.slug}`);
        };
      }

      if (playerControlNext) {
        playerControlNext.onclick = () => {
          this.$router.push(`/curso/${this.$route.params.course_id}/lecciones/${this.content.next.module}/${this.content.next.slug}`);
        };
      }

      document.querySelector('#controls').addEventListener('click', () => {
        this.player.getPaused().then((paused) => {
          if (paused) this.player.play();
          else this.player.pause();
        });
      });
    },
    initTrackingTimeWatched() {
      window.setInterval(() => {
        if (
          this.currentProgressLesson
          && this.progressVideoTime.seconds > this.currentProgressLesson.lesson_time_watched
          && this.progressVideoTime.seconds !== this.progressVideoTime.duration
        ) {
          this.saveTimeWatched(this.progressVideoTime);
        }
      }, 20000);
    },
    cancelAutoplayNextLection() {
      this.autoPlayTransition.enable = false;
      this.frezedAutoplay = true;
    },
    playNextLection() {
      this.frezedAutoplay = true;

      this.$router.push(`/curso/${this.$route.params.course_id}/lecciones/${this.content.next.module}/${this.content.next.slug}`);
    },

    initTooltips() {
      if (!this.content.tooltips) {
        window.setTimeout(() => {
          tippy('.c-tooltip-toggle', {
            content(reference) {
              return `<p class="c-tooltip c-tooltip--tiny">´
                ${reference.getAttribute('data-content')}
                </p>
              `;
            },
            allowHTML: true,
            theme: 'light',
            animation: 'scale',
            inertia: true,
          });

          this.content.tooltips = true;
        }, 2000);
      }
    },

    hideSidebar(time = 'update') {
      if (this.device === 'desktop') {
        if (time === 'update') this.sidebar.status = (this.sidebar.status === 1) ? 0 : 1;

        localStorage.setItem('sidebarStatus', this.sidebar.status);
      }
    },
    runActions() {
      if (
        this.course.title && this.course.progress
        && this.content.body && this.user
        && this.course.enroll
      ) {
        this.saveProgress();
        this.setMixpanelBaseData();
      } else {
        this.content.loading = false;
      }
    },
    runActionsPlayer() {
      if ((this.content.previous || this.content.next) && this.player) {
        this.initPlayerControls(document.querySelector('.video-embed'));
      }
    },
    fillRatingStar() {
      this.ratingStatus = true;
    },
    markAsCompleted(hasStarted, hasEnded) {
      const request = `${window.arcux.site}/api/v1/mixpanel/lection-completed/`;
      const formData = new FormData();

      formData.append('event', JSON.stringify({
        course: {
          ...this.mixpanel.course,
          started: hasStarted,
          ended: hasEnded,
        },
        lesson: this.mixpanel.lesson,
      }));

      formData.append('people', JSON.stringify({
        email: (this.user) ? this.user.email : false,
      }));

      fetch(request, {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then(() => { })
        .catch((err) => {
          throw err;
        });
    },
    markAsWatched() {
      const request = `${window.arcux.site}/api/v1/mixpanel/lection-watched/`;
      const formData = new FormData();

      formData.append('event', JSON.stringify({
        course: {
          ...this.mixpanel.course,
        },
        lesson: this.mixpanel.lesson,
      }));

      formData.append('people', JSON.stringify({
        email: (this.user) ? this.user.email : false,
      }));

      fetch(request, {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then(() => { })
        .catch((err) => {
          throw err;
        });
    },

    setMixpanelBaseData() {
      const categories = [...this.course.details.categories.map((cat) => cat.name)];
      const softwares = [...this.course.details.softwares.map((cat) => cat.name)];

      let time = this.content.body.time ? this.content.body.time.split(':') : false;

      if (time && time.length === 3) {
        time = (Number(time[0]) * 60) + (Number(time[1])) + (Number(time[2]) / 60);
      } else time = 0;

      this.mixpanel = {
        course: {
          id: this.$route.params.course_id,
          name: this.course.title,
          level: (this.course.details.level) ? this.course.details.level : '-',
          type: (window.arcux.course_is_free && Number(window.arcux.course_is_free) === 1) ? 'Free' : 'Premium',
          category: categories,
          software: softwares,
          access: '-',
        },
        lesson: {
          duration: time,
          number: this.content.body.index,
          name: this.content.body.title,
          fullName: `${this.content.body.index} - ${this.content.body.title}`,
        },
      };
    },
    saveTimeWatched(progress) {
      /* TODO: API + Add course_free + change course_id */
      const time = (progress.percent * 100 >= 80) ? progress.duration : progress.seconds;
      const request = `${window.arcux.site}/api/v1/students/${this.user.id}/courses/${this.$route.params.course_id}/progress/${this.currentProgressLesson.id}`;

      fetch(request, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${window.arcux.token}`,
        },
        body: JSON.stringify({ lesson_time_watched: time }),
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            console.log('%cArcux [🏡] - Progreso guardado ❤️‍🔥 (in silence...)', 'color: #7DB40D;');

            this.currentProgressLesson.lesson_time_watched = time;
          }
        })
        .catch((err) => {
          this.content.loading = false; throw err;
        });
    },
  },
};
</script>
